"use client";

import { useBlogLocaleNavigation, useSiteLocale } from "./CcLocaleContext";
import { getSiteUiCopy } from "@/lib/site-ui-copy";

/** Shared UI follows the blog language when present, otherwise the marketing locale. */
export function useCopyLang() {
  const locale = useSiteLocale();
  const { navigation } = useBlogLocaleNavigation();
  return navigation?.lang ?? locale;
}

export function useSiteUiCopy() {
  return getSiteUiCopy(useCopyLang());
}
